module.exports = __webpack_public_path__ + "img/front-door-right-i.ad5ef45c.svg";